<div [@openClosePopup]="visible ? 'open' : 'closed'" class="popup-container">
  <div class="popup-content">
    <button (click)="close()" class="close-button" mat-flat-button>
      <span class="material-icons">close</span>
    </button>
    <div class="embed-responsive embed-responsive-16by9">
      <iframe *ngIf="visible" [src]="embeddedLink" allowfullscreen class="embed-responsive-item"></iframe>
    </div>
  </div>
</div>
